import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { StorageService } from '../service/storage.service';

const SERVER_NAME = 'IMS';

const PUBLIC_API_PATHS: readonly string[] = ['/signin', '/building/image_view/'];

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const isPublicApi = PUBLIC_API_PATHS.some((path: string) => request.url.includes(path));

  const requestWithServerHeader = request.clone({
    setHeaders: {
      server: SERVER_NAME,
    },
  });

  /*
   * Login, send OTP, forgot password and public image APIs
   * will be sent without the Authorization header.
   */
  if (isPublicApi) {
    return next(requestWithServerHeader);
  }

  const token = storageService.getToken();

  if (!token) {
    storageService.removeIdentity();
    void router.navigate(['/signin']);

    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: 'Authentication token not found',
          url: request.url,
        }),
    );
  }

  const authenticatedRequest = requestWithServerHeader.clone({
    setHeaders: {
      Authorization: `Bearer ${String(token)}`,
    },
  });

  return next(authenticatedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        storageService.removeIdentity();
        void router.navigate(['/signin']);
      }

      return throwError(() => error);
    }),
  );
};
